import {
  DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES,
  DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES,
  CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES,
  DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES,
  SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES,
  DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES,
  DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES,
  CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES
} from './constants';

const initialState = {
  activeRules: [],
  eventTypes: [],
  deactivateModal: {}
};

const initialRuleState = {
  id: '',
  parentEventName: 'Not Specified',
  childEventName: 'Not Specified',
  quantity: 0,
  inactiveDate: null,
  creationDate: null,
  description: ''
};

const reducer = (state = initialState, {type, payload}) => {
 switch (type) {
   case DEACTIVATE_PROCESS_END_FOR_BUNDLING_RULES:
     return {
       ...state,
       ...{deactivateModal: {
         ...state.deactivateModal,
         submitting: false
       }}
     };
   case DEACTIVATE_PROCESS_START_FOR_BUNDLING_RULES:
     return {
       ...state,
       ...{deactivateModal: {
         ...state.deactivateModal,
         submitting: true
       }}
     };
   case CANCEL_DEACTIVATE_MODAL_FOR_BUNDLING_RULES:
     return {
       ...state,
       ...{deactivateModal: {}}
     };
   case DISPLAY_DEACTIVATE_MODAL_FOR_BUNDLING_RULES:
     return payload
       ? {
          ...state,
          ...{deactivateModal: {
            ...payload,
            visible: true
          }}
        }
        : state;
   case SET_EVENT_TYPES_IN_STATE_FOR_BUNDLING_RULES:
    return payload
      ? {
        ...state,
        ...{eventTypes: payload}
      }
      : state;
    case DISPLAY_NEW_BUNDLING_RULE_FOR_BUNDLING_RULES:
      return {
        ...state,
        ...{
          activeRules: [
            {
              ...initialRuleState,
              ...{editing: true}
            },
            ...state.activeRules
          ]
        }
      };
    case CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES:
      return {
        ...state,
        ...{
          activeRules: state.activeRules
            .map(activeRule => ruleReducer(activeRule, {type}))
            .filter(activeRule => activeRule.id) // return only items with information (not empty ones)
        }
      };
    case DISPLAY_ACTIVE_RULES_FOR_BUNDLING_RULES:
      return payload
       ? {
          ...state,
          ...{activeRules: payload}
         }
       : state;
   default:
     return state;
 }
};

const ruleReducer = (state = {}, {type}) => {
  switch (type) {
    case CANCEL_BUNDLING_RULE_FORM_FOR_BUNDLING_RULES:
      return {
        ...state,
        ...{editing: false}
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/restrictions/bundles/reducer.js